import React from 'react';
import { BookOpen, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import './TrainingPages.css';

const POLLEN_BEE_IMG = "https://customer-assets.emergentagent.com/job_bee-booking/artifacts/k8zgjyqb_Pollen%20-%20bHyyve%20Mascot.png";

const MyCourses = () => {
  const navigate = useNavigate();

  return (
    <div className="training-page">
      {/* Banner */}
      <div className="training-banner">
        <div className="banner-content">
          <h1>My Courses</h1>
          <p>Build your expertise with professional training modules</p>
        </div>
        <img src={POLLEN_BEE_IMG} alt="Pollen" className="banner-bee" />
      </div>

      {/* Empty State */}
      <div className="empty-state">
        <div className="empty-icon">
          <BookOpen size={64} />
        </div>
        <h2>Courses Coming Soon</h2>
        <p>We are building professional training courses tailored to your business category. Check back soon!</p>
        <Button 
          className="back-btn"
          onClick={() => navigate('/yourhyyve')}
        >
          <ArrowLeft size={18} />
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default MyCourses;
